import { render, staticRenderFns } from "./upload-muti.vue?vue&type=template&id=4b5fd4e9&scoped=true"
import script from "./upload-muti.vue?vue&type=script&lang=js"
export * from "./upload-muti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fd4e9",
  null
  
)

export default component.exports